// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"right-column_wrapper__zki6g","stickyBlock":"right-column_stickyBlock__bLYd7","sideBanner":"right-column_sideBanner__jOf56"};